/**
 * @generated SignedSource<<1f1f405419e361d33e29da0befdfad84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_viewer">;
  readonly " $fragmentType": "PdpRespSimilarItemsGrid_viewer";
};
export type PdpRespSimilarItemsGrid_viewer$key = {
  readonly " $data"?: PdpRespSimilarItemsGrid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsGrid_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespRelatedItem_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0772c56bee9aeeea4d84917737999569";

export default node;
